import Button from "../../Button/Button";
import "./TicketTab.css";

type TicketStatus = string | { key: string; label?: string; color?: string };

type Ticket = {
  id: number;
  ticket_no: number;
  subject: string;
  updated_at: string;
  status?: TicketStatus;
  priority?: string;
};

type TicketsTabProps = {
  tickets: Ticket[];
  showId?: boolean;
  showSubject?: boolean;
  showLastModification?: boolean;
  showStatus?: boolean;
  showPriority?: boolean;
  showButton?: boolean;
  emptyLabel?: string;
};

export default function TicketsTab({
  tickets,
  showId = true,
  showSubject = true,
  showLastModification = true,
  showStatus = true,
  showPriority = true,
  showButton = true,
  emptyLabel = "Aucun ticket.",
}: TicketsTabProps) {
  if (!tickets.length) {
    return <p className="tickets-empty">{emptyLabel}</p>;
  }

  return (
    <ul className="tickets-stack">
      {tickets.map((ticket) => (
        <li key={ticket.id} className="tickets-item">
          <div className="tickets-item__content">
            <div className="tickets-item__info">
              {showId && <span className="tickets-item__id">#{ticket.ticket_no}</span>}
              {showSubject && <span className="tickets-item__subject">{ticket.subject}</span>}
              {showLastModification && (
                <span className="tickets-item__meta">
                  Dernière mise à jour : {new Date(ticket.updated_at).toLocaleString("fr-FR")}
                </span>
              )}
            </div>
            <div className="tickets-item__status">
              {showStatus && ticket.status && (
                <span className="badge">
                  {typeof ticket.status === "string"
                    ? ticket.status
                    : ticket.status.label || ticket.status.key}
                </span>
              )}
              {showPriority && ticket.priority && (
                <span className="badge badge--priority">{ticket.priority}</span>
              )}
            </div>
            {showButton && (
              <Button
                type="link"
                value="Voir le ticket"
                variant="primary"
                size="small"
                linkHref={`/ticket/${ticket.id}`}
              />
            )}
             
          </div>
        </li>
      ))}
    </ul>
  );
}